export default __webpack_public_path__ + "static/flipImg5-8eebe2efb5301129eccdce8d2dd54ccb.webp";